import { api } from '../../../../config/api';
import { callsActions } from '../../actions';
import schema from '../../schemas/callsSchema.json';
import { makeRequestWorker } from '../../../../workers/makeRequestWorker';

export function* getCallFieldsWorker({ payload }) {
    const options = {
        fetcher: api.calls.getPostCallFields,
        fetcherParam: payload,
        successAction: callsActions.fillCallFields,
        startFetching: callsActions.startFetchingCallFields,
        stopFetching: callsActions.stopFetchingCallFields,
        setErrorAction: callsActions.getCallFieldsError,
        schema,
    };

    yield makeRequestWorker(options);
}
